var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4089_11589)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M82 140C47.8109 140 20 112.186 20 78.0072C20 43.8285 47.8109 16 82 16C116.189 16 144 43.8142 144 78.0072C144 112.2 116.189 140 82 140Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.234 78.0007C137.234 108.498 112.512 133.221 81.9999 133.221C51.4883 133.221 26.7803 108.498 26.7803 78.0007C26.7803 47.5029 51.5027 22.7656 82.0143 22.7656C112.526 22.7656 137.248 47.4885 137.248 78.0007H137.234Z",
    fill: "url(#paint0_linear_4089_11589)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5,
    d: "M137.234 78.0007C137.234 108.498 112.512 133.221 81.9999 133.221C51.4883 133.221 26.7803 108.498 26.7803 78.0007C26.7803 47.5029 51.5027 22.7656 82.0143 22.7656C112.526 22.7656 137.248 47.4885 137.248 78.0007H137.234Z",
    fill: "url(#paint1_linear_4089_11589)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.673 77.4696L60.5677 74.065C60.3522 73.9358 60.0793 73.9501 59.8494 74.065L44.3204 83.1871C43.8463 83.46 43.8463 84.1352 44.3204 84.4225L49.061 87.2668L66.6586 77.4696H66.673Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1023 83.2879L71.313 80.0557L53.543 89.9391L59.8638 93.7315C60.0792 93.8608 60.3522 93.8608 60.582 93.7315L77.1023 84.5233C77.5907 84.2503 77.5907 83.5464 77.1023 83.2735V83.2879Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8724 96.8054L53.5428 93.6881V100.138L49.0321 97.6098V91.0592L42.6682 87.3386C42.1942 87.0656 41.5908 87.4104 41.5908 87.9563V106.559C41.5908 106.818 41.7345 107.062 41.9643 107.192L58.1685 116.17C58.6426 116.429 59.2316 116.084 59.2316 115.538V97.4231C59.2316 97.1645 59.1023 96.9347 58.8724 96.8054Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.869 87.3383L62.6648 96.8194C62.4493 96.9487 62.3057 97.1786 62.3057 97.4372V115.552C62.3057 116.098 62.8946 116.443 63.3687 116.184L79.5729 107.206C79.8027 107.076 79.9464 106.846 79.9464 106.574V87.9704C79.9464 87.4245 79.343 87.0797 78.869 87.3526V87.3383Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.676 77.4696L102.571 74.065C102.356 73.9358 102.083 73.9501 101.853 74.065L86.3238 83.1871C85.8497 83.46 85.8497 84.1352 86.3238 84.4225L91.0644 87.2668L108.662 77.4696H108.676Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M119.105 83.2879L113.316 80.0557L95.5459 89.9391L101.867 93.7315C102.082 93.8608 102.355 93.8608 102.585 93.7315L119.105 84.5233C119.594 84.2503 119.594 83.5464 119.105 83.2735V83.2879Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.876 96.8054L95.5468 93.6881V100.138L91.036 97.6098V91.0592L84.6721 87.3386C84.1981 87.0656 83.5947 87.4104 83.5947 87.9563V106.559C83.5947 106.818 83.7384 107.062 83.9682 107.192L100.172 116.17C100.646 116.429 101.235 116.084 101.235 115.538V97.4231C101.235 97.1645 101.106 96.9347 100.876 96.8054Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.872 87.3383L104.668 96.8194C104.452 96.9487 104.309 97.1786 104.309 97.4372V115.552C104.309 116.098 104.898 116.443 105.372 116.184L121.576 107.206C121.806 107.076 121.949 106.846 121.949 106.574V87.9704C121.949 87.4245 121.346 87.0797 120.872 87.3526V87.3383Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2726 41.5849L81.1673 38.1803C80.9518 38.051 80.6789 38.0654 80.449 38.1803L64.92 47.3023C64.4459 47.5753 64.4459 48.2504 64.92 48.5378L69.6606 51.3821L87.2582 41.5849H87.2726Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7019 47.4035L91.9126 44.1713L74.1426 54.0547L80.4634 57.8471C80.6788 57.9764 80.9518 57.9764 81.1816 57.8471L97.7019 48.6389C98.1903 48.366 98.1903 47.6621 97.7019 47.3891V47.4035Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4725 60.9206L74.1429 57.8033V64.2534L69.6322 61.7251V55.1745L63.2683 51.4538C62.7943 51.1809 62.1909 51.5256 62.1909 52.0715V70.6748C62.1909 70.9333 62.3346 71.1775 62.5644 71.3068L78.7686 80.2852C79.2427 80.5438 79.8317 80.199 79.8317 79.6531V61.5383C79.8317 61.2798 79.7024 61.0499 79.4725 60.9206Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4686 51.4395L83.2644 60.9206C83.0489 61.0499 82.9053 61.2798 82.9053 61.5383V79.6531C82.9053 80.199 83.4943 80.5438 83.9683 80.2852L100.173 71.3068C100.402 71.1775 100.546 70.9477 100.546 70.6748V52.0715C100.546 51.5256 99.9427 51.1809 99.4686 51.4538V51.4395Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4089_11589",
    x: 0,
    y: 0,
    width: 164,
    height: 164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4089_11589"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4089_11589",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4089_11589",
    x1: 81.9999,
    y1: 22.7656,
    x2: 81.9999,
    y2: 133.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80BC00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4089_11589",
    x1: 81.9999,
    y1: 22.7656,
    x2: 81.9999,
    y2: 133.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CDDE00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80BC00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.0d315104815d0d90a27430bed7e272c6.svg";
export { ForwardRef as ReactComponent };